import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {DisplayColumnsPesquisaEntidade} from '../models/display-columns-pesquisa-entidade';
import {isNullOrUndefined} from '../../../../../../../utils/util';
import { MensagensService } from 'max-ng-lib';

@Component({
  selector: 'm-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => CustomSelectComponent),
		multi: true
	}]
})
export class CustomSelectComponent implements OnInit, ControlValueAccessor {

	pesquisaInputForm: FormGroup;
	innerValue: any;
	lista = [];
	private BARRA_ESPACO = 32;
	@Input() exibirMarcarTodos = true;

	listaFiltrada;
	todosItensSelecionados = false;

	@Output() change = new EventEmitter();

	@Input() modelo: any;
	@Input() habilitarAutoComplete = true;
	@Input() idCustomSelect = 'idSelect';
	@Input() placelholder;
	/** Quando nao quiser o objeto inteiro selecionado.
	 *  passar qual propriedade deseja atribuir ao form
	 */
	@Input() propriedadeSelecionadoItem = '';
	/** Propriedade utilizada para filtrar quando vier o value. */
	@Input() propriedadeFind = 'id';
	/** Propriedades que irao aparecer na tela. Passar [''] */
	@Input() colunasApresentacao: DisplayColumnsPesquisaEntidade[] = [
		{ titulo: 'Descricao', propriedade: 'descricao', minWidth: '100px', maxWidth: '300px' }
	];
	@Input() propriedadesDisplay: string[];
	@Input() multiple = false;
	@Input() required = false;
	@Input() disabled = false;
	@Input() set provider(value) {
		this.lista = value;
		this.listaFiltrada = value;
		this.buscarValorDoProvider(this.innerValue);
	}

	@Input() maximo = 1000;

	onChange: (_: any) => void = (_: any) => { };

	onTouched: () => void = () => { };

	constructor(private fb: FormBuilder, private mensagem: MensagensService) { }

	ngOnInit() {
		this.criarFormulario();
	}

	set value(item) {
		item = this.obterValorItem(item);

		if(item.length > this.maximo) {
			item = item.slice(0, this.maximo);
			this.mensagem.exibaToastAlerta('O máximo de itens selecionados é ' + this.maximo + '!');
		}

		let valor;
		if (this.propriedadeSelecionadoItem) {
			if (this.multiple) {
				valor = item.map(i => i[this.propriedadeSelecionadoItem]);
			} else {
				valor = item[this.propriedadeSelecionadoItem];
			}

		} else {
			valor = item;
		}

		this.innerValue = item;

		this.onChange(valor);

	}

	get value() {
		return this.innerValue;
	}

	obterValorItem(item) {
		if (this.multiple && item) {
			item = item.filter(f => f !== null);
		}
		return item;
	}

	funcaoDisplay = (item) => {
		let valor = '';

		if (this.propriedadesDisplay) {
			this.propriedadesDisplay.forEach(element => {
				if (item[element]) {
					valor += `${valor.length > 0 ? ' - ' : ''}${item[element]}`;
				}
			});
		} else {
			valor = item;
		}

		return valor;
	}

	writeValue(value): void {
		this.innerValue = value;
		this.buscarValorDoProvider(value);

		this.validarToogle();
	}

	private validarToogle() {
		if (isNullOrUndefined(this.innerValue) || this.innerValue.length === 0) {
			this.todosItensSelecionados = false;
		} else {
			this.todosItensSelecionados = true;
		}
	}

	private buscarValorDoProvider(value) {
		if (this.innerValue && this.lista && this.lista.length > 0) {
			if (this.multiple) {
				const selecionados = [];
				value
					.filter(f => f !== null)
					.forEach(v => {
						const val = typeof v === 'object' ? v[this.propriedadeFind] : v

						const itemProvider = this.lista.find(e => e[this.propriedadeFind] === val);
						if (itemProvider) {
							selecionados.push(itemProvider);
						}
					});
				this.innerValue = selecionados;
			} else {
				const val = typeof value === 'object' ? value[this.propriedadeFind] : value

				this.innerValue = this.lista.find(e => e[this.propriedadeFind] === val);
			}
		}
	}

	selecionarTodos() {
		if (this.todosItensSelecionados) {
			this.value = [];
		} else {
			this.value = this.lista;
		}

		this.todosItensSelecionados = !this.todosItensSelecionados;
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	// PROPRIEDADES INPUT

	keyDownPesquisa(event: KeyboardEvent) {
		if (event.keyCode === this.BARRA_ESPACO) {
			event.stopPropagation();
		}
	}

	criarFormulario() {
		this.pesquisaInputForm = this.fb.group({
			pesquisaInput: ''
		});
		this.mudancasNoValorDoInput();
	}

	mudancasNoValorDoInput() {
		this.pesquisaInputForm.get('pesquisaInput').valueChanges.pipe(
			debounceTime(300),
			distinctUntilChanged()
		).subscribe(result => {
			this.pesquise(result);
		});
	}

	pesquise(valueInput) {
		const termoDaPesquisa = valueInput;
	
		const textosDaPesquisa = termoDaPesquisa
			.toLowerCase()
			.split(' ');
	
		this.listaFiltrada = this.lista.filter(item => this.itemSatisfazAPesquisa(item, textosDaPesquisa));
	
	
		if (this.multiple && this.innerValue) {
			const itensNaoSelecionados = this.listaFiltrada.filter(i => !this.innerValue.includes(i));
			const itensSelecionados = this.innerValue.filter(i => this.lista.includes(i));
			this.listaFiltrada = [...itensNaoSelecionados, ...itensSelecionados];
		}
	}


	itemSatisfazAPesquisa(item: any, textos: string[]): boolean {
		for (const texto of textos) {
			let algumCampoSatisfaz = false;
			for (const coluna of this.propriedadesDisplay) {
				const valor = item[coluna];
				if (this.removeAcentos(valor).toLowerCase().includes(this.removeAcentos(texto).toLowerCase())) {
					algumCampoSatisfaz = true;
					break;
				}
			}
			if (!algumCampoSatisfaz) {
				return false;
			}
		}
		return true;
	}

	removeAcentos(texto: string): string {
		texto = texto ? texto.toString() : '';
		texto = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
		return texto;
	}



	trocarItem() {
		this.change.emit();
	}


}
